/* eslint-disable react/no-string-refs */
/* eslint-disable camelcase */
/* eslint-disable no-shadow */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-unused-state */
/* eslint-disable import/no-extraneous-dependencies */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import Cookies from "universal-cookie";
import { ChaloReactHybridLogin } from "@chalo/chalo-react-login-libraries";
import "@chalo/chalo-react-login-libraries/dist/index.css";
import { GenericLoader, Notification as NotificationComponent, hideLoading } from "../../shared/widgets";

import { logoutUser, setTokenExpired, updateUser } from "../../redux/actions/authActions";

import {
  fetchAccessToken,
  fetchLoggedInUser,
  maintainReconUser,
} from "../../services/login/loginService";
import "./signInComponent.css";
import {
  updateUserLoginState,
  extractToken,
  encryptString,
} from "../../services/authorization";
import { messages, MessageType } from "../../Constant";
import config from "../../config";

const cookies = new Cookies();

class SignInComponent extends Component {
  constructor(props) {
    super(props);
    this.fetchAccessToken = this.fetchAccessToken.bind(this);
    this.state = {
      redirectToReferrer: false,
      userName: null,
      userId: null,
      showSigin: false,
      phoneNumber: "",
      isVerifyOTP: false,
      isSendOTP: false,
      OTP: [],
      isLoading: false,
    };
  }

  componentDidMount() {
    /**
     * Used to get refrence of notificationSystem into "this".
     */
    // eslint-disable-next-line react/no-string-refs
    this._notificationSystem = this.refs.notificationSystem;
    this.mounted = true;
    const user = cookies.get(config.cookieKeys.user);
    if (user) {
      this.setState(
        {
          userId: user,
          showSigin: false,
        },
        () => {
          this.signInthroughUsername();
        },
      );
    } else {
      this.setState({
        showSigin: true,
      });
    }
  }

  componentDidUpdate() {
    const { userLogout: userLogoutProp, isTokenExpired } = this.props;
    if (isTokenExpired) userLogoutProp();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  processLoginResponse = (response) => {
    const { access_token, username } = response;
    const { updateUser: updateUserProp, setTokenExpired: setTokenExpiredProp } = this.props;

    if (access_token) {
      if (username) {
        const current_date = new Date();
        const expiration_date = new Date();
        expiration_date.setDate(current_date.getDate() + 7);
        const encryptedUserCookie = encryptString(username);
        cookies.set(config.cookieKeys.user, encryptedUserCookie, {
          domain: ".chalo.com",
          expires: expiration_date,
        });

        const encryptedLoginCookie = encryptString("loggedIn");

        cookies.set(config.cookieKeys.loginState, encryptedLoginCookie, {
          domain: ".chalo.com",
          expires: expiration_date,
        });
        localStorage.setItem("username", username);
      }
      new Promise((resolve) => {
        resolve(extractToken(response));
      })
        .then((response) => {
          updateUserProp(response);
          return response;
        })
        .then((response) => {
          this.setState({ isLoading: true });
          return maintainReconUser(response);
        })
        .then((response) => {
          this.setState({ isLoading: false });
          const { token } = response;
          if (token) setTokenExpiredProp(false);
          this.updateLoginState(token);
        })
        .catch((err) => {
          this.setState({
            loading: false,
            showSigin: true,
          });
          this._addNotification(
            MessageType.ERROR,
            err.description || err.error_description || err.message || messages.auth_token_error,
          );
        });
    } else {
      this._addNotification(
        MessageType.ERROR,
        response.response.data.error_description || "Error",
      );
    }
  };

  /**
   * Used to show Notifications
   * @param  type Type of Notification
   * @param  msg   Message to Show
   */
  _addNotification(type, msg) {
    this._notificationSystem._addNotification(type, msg);
  }

  fetchAccessToken(userName, password, userId) {
    fetchAccessToken(userName, password, userId)
      .then((response) => {
        if (userId) {
          const current_date = new Date();
          const expiration_date = new Date();
          expiration_date.setDate(current_date.getDate() + 7);
          const encryptedUserCookie = encryptString(userId);
          cookies.set(config.cookieKeys.user, encryptedUserCookie, {
            domain: ".chalo.com",
            expires: expiration_date,
          });

          const encryptedLoginCookie = encryptString("loggedIn");

          cookies.set(config.cookieKeys.loginState, encryptedLoginCookie, {
            domain: ".chalo.com",
            expires: expiration_date,
          });
          localStorage.setItem("userId", userId);
        }
        return extractToken(response);
      })
      .then((response) => {
        updateUser(response);
        return response;
      })
      .then((response) => maintainReconUser(response))
      .then((response) => {
        const { token } = response;
        this.updateLoginState(token);
      })
      .catch((err) => {
        this.setState({
          loading: false,
          showSigin: true,
        });
        this._addNotification(
          MessageType.ERROR,
          err.description || err.error_description || err.message || messages.auth_token_error,
        );
      });
  }

  signInthroughUsername() {
    const { userId } = this.state;
    fetchLoggedInUser(userId)
      .then((response) => {
        if (response.status !== "UNAUTHORIZED") {
          this.fetchAccessToken(response.username, response.password);
        } else {
          this.setState({
            showSigin: true,
          });
        }
      })
      .catch((err) => {
        this.setState({
          showSigin: true,
        });
        this._addNotification(
          MessageType.ERROR,
          err.description || err.error_description || err.message || messages.user_info_error,
        );
      });
  }

  updateLoginState(token) {
    updateUserLoginState(token)
      .then(() => {
        const redirectUrl = "/";
        this.setState({ redirectToReferrer: true, loading: false, redirectTo: redirectUrl });
      })
      .catch((err) => {
        if (this.mounted) {
          this._addNotification(MessageType.ERROR, err);
        }
      });
  }

  render() {
    const { redirectToReferrer, redirectTo, isLoading } = this.state;
    if (redirectToReferrer) {
      return <Redirect to={redirectTo} />;
    }
    return (
      <div>
        {isLoading && <GenericLoader absolute className="top-zero" />}
        <ChaloReactHybridLogin
          googleProperties={config.googleProperties}
          cookieKeys={config.cookieKeys}
          hasMobileLogin
          hasUserLogin
          onLoginResponse={(event) => {
            this.processLoginResponse(event.data);
          }}
        />
        <div>
          <div className=" body-container">
            <NotificationComponent ref="notificationSystem" />
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    isTokenExpired: state.Auth.isTokenExpired,
  };
}
const mapDispatchToProps = (dispatch) => ({
  setTokenExpired: (value) => {
    dispatch(setTokenExpired(value));
  },
  updateUser: (value) => {
    dispatch(updateUser(value));
  },
  userLogout: () => {
    dispatch(hideLoading("header"));
    dispatch(logoutUser(null));
    dispatch(updateUser({}));
    updateUserLoginState(null);
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(SignInComponent);
